import React from 'react';
import { browserHistory } from 'react-router';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import rootReducer from './rootReducer';

const middleware = routerMiddleware(browserHistory);
const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

export function configureStore(initialstate) {
  const store = createStore(
    rootReducer,
    initialstate,
    // To enable the devToolsExtension
    composeEnhancers(
      applyMiddleware(middleware, thunk),
    ),
  );

  return store;
}
